































import { log } from '@/log'
import { ContractedSubscription } from '@/models/order/subscription/contracted/contracted-subscription'
import { ContractedSubscriptionListRepository } from '@/models/order/subscription/contracted/contracted-subscription-repository'
import { DefaultContractedSubscriptionRepository } from '@/models/order/subscription/contracted/repository/default/default-contracted-subscription-repository'
import { ApiClientWithAuth } from '@/services/api/client'
import ContractedSubscriptionListItem from '@spa/components/pages/mypage/subscription/contracted/list/ContractedSubscriptionListItem.vue'
import LoadingMixin, { Status } from '@spa/mixins/loading'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ContractedSubscriptionListItem,
  },
})
export default class ContractedSubscriptionListPage extends Mixins<LoadingMixin>(LoadingMixin) {
  @Prop({ default: () => new DefaultContractedSubscriptionRepository(ApiClientWithAuth) })
  readonly contractedSubscriptionRepository: ContractedSubscriptionListRepository

  contractedSubscriptions: ContractedSubscription[] = []

  status: Status = Status.Pending

  async created() {
    this.status = Status.Loading

    try {
      this.contractedSubscriptions = await this.contractedSubscriptionRepository.list()

      this.status = Status.Completed
    } catch (error) {
      log.error({ error })

      this.status = Status.Failed
    }
  }

  get isLoading(): boolean {
    return this.status === Status.Loading
  }
}
